export default "__VITE_PUBLIC_ASSET__1e41f79b__"